const routes = [
    //{
    //    path: '/leads/available_leads',
    //   name: 'AvailableLeads',
    //    component: () => import( /* webpackChunkName: "leads" */ '../views/Leads/AvailableLeads.vue')
    //},
    {
        path: '/leads',
        name: 'Leads',
        component: () => import( /* webpackChunkName: "leads" */ '../views/Leads/Leads.vue')
    },
    {
        path: '/leads/dx-lead-orders',
        name: 'My DX Lead Orders',
        component: () => import( /* webpackChunkName: "leads" */ '../views/LeadOrders/DxLeadOrders/AgentDxLeadOrders.vue'),
        meta: {
            permission: ['agent:DXLeadOrders']
        }
    },
    {
        path: '/leads/dx-lead-orders-by-state',
        name: 'DX Lead Orders by State',
        component: () => import( /* webpackChunkName: "leads" */ '../views/LeadOrders/DxLeadOrders/DxLeadOrdersByState.vue'),
        meta: {
            permission: ['SuperAdmin', 'Staff', 'Exec'],
        }
    },
    {
        path: '/leads/dx-allocate-leads',
        name: 'Allocate DX Leads',
        component: () => import( /* webpackChunkName: "leads" */ '../views/LeadOrders/DxLeadOrders/AllocateDXLeads.vue'),
        meta: {
            permission: ['SuperAdmin', 'Staff', 'Exec'],
        }
    },
    {
        path: '/leads/recruiting-lead-orders',
        name: 'Recruiting Lead Orders',
        component: () => import( /* webpackChunkName: "leads" */ '../views/LeadOrders/Recruiting/AgentRecruitingLeadOrders.vue'),
        meta: {
            permission: ['agent:RecruitingLeadOrders']
        }
    },
    {
        path: '/leads/quility-digital-lead-orders',
        name: 'Quility Digital Lead Orders',
        component: () => import( /* webpackChunkName: "leads" */ '../views/LeadOrders/QuilityDigitalLeads/AgentDigitalLeadOrders.vue'),
        meta: {
            permission: ['agent:Quility Digital LeadLeadOrders']
        }
    },
    {
        path: '/leads/dfl-lead-orders',
        name: 'Debt Free Life Lead Orders',
        component: () => import( /* webpackChunkName: "leads" */ '../views/LeadOrders/QuilityDigitalLeads/AgentDflLeadOrders.vue'),
        meta: {
            // permission: ['agent:Debt Free LifeLeadOrders']
        }
    },
    {
        path: '/leads/approve-digital-lead-orders',
        name: 'Approve Digital Lead Orders',
        component: () => import( /* webpackChunkName: "leads" */ '../views/LeadOrders/QuilityDigitalLeads/ApproveDigitalLeadOrders.vue'),
        meta: {
            permission: ['AgencyOwner', 'SuperAdmin', 'Staff', 'Exec'],
        }
    },
    {
        path: '/leads/lead-sales-summary',
        name: 'Lead Sales Summary',
        component: () => import( /* webpackChunkName: "leads" */ '../views/Agent/AgentAccounts/LeadOrderReceiptSummary.vue'),
        meta: {
            permission: ['SuperAdmin', 'Staff', 'Exec'],
        }
    },
    {
        path: '/leads/lead-sales-receipts',
        name: 'Lead Sales Receipts',
        component: () => import( /* webpackChunkName: "leads" */ '../views/Agent/AgentAccounts/LeadOrderReceipts.vue'),
        meta: {
            permission: ['SuperAdmin', 'Staff', 'Exec'],
        }
    },
    {
        path: '/leads/existing-lead-order-auction',
        name: 'Existing Lead Order Auction',
        component: () => import( /* webpackChunkName: "leads" */ '../views/LeadOrders/Auction/ExistingLeadOrderAuction.vue')
    },
]

export default routes